<template>
  <div>
    <PageHeader :title="title" :items="items"/>
    <div class="card">
      <div class="card-body">

        <div class="col-sm-12">
          <div class="row">
            <div class="col-sm-6 col-12">
              <PerPageSelector v-model="query.perPage"
                               :available-per-page-options="availablePerPageOptions"
              ></PerPageSelector>
            </div>
            <div class="col-sm-3 offset-lg-3 offset-md-3 offset-sm-3 col-12">
              <DataTableSearch v-model="query.filter"
                               :place-holder="$t('pages.queue.search')"/>
            </div>
          </div>
        </div>

        <div class="col-sm-12">
          <div>
            <b-table
                ref="queueTable"
                striped
                :empty-text="$t('components.bootstrap_table.empty_text')"
                :empty-filtered-text="$t('components.bootstrap_table.empty_filtered_text')"
                hover
                fixed
                :fields="fields"
                :items="getQueue"
                :per-page="query.perPage"
                :sort-by="query.sortBy"
                :sort-desc="query.sortDesc"
                :current-page="query.page"
                show-empty
                :stacked="$store.state.app.isMobile"
                :filter="query.filter"
            >

              <template v-slot:cell(campaign)="data">
                <a @click="$helpers.openNewTab('campaign.edit',{ campaignId : data.item.campaign.id })"
                   href="javascript: void(0);">
                  <i class="mdi mdi-open-in-new"></i>
                  {{ data.item.campaign.name }}
                </a>
              </template>

              <template v-slot:cell(order_id)="data">
                <h5>
                  <b-badge variant="light">
                    {{ data.item.order.amazon_order_id }}
                  </b-badge>
                </h5>
              </template>

              <template v-slot:cell(feedback_status)="data">
                <h5>
                  <b-badge
                      :variant="feedbackStatus[data.item.scheduled_notification.status].variant">
                    {{ feedbackStatus[data.item.scheduled_notification.status].text }}
                  </b-badge>
                </h5>
              </template>

              <template v-slot:cell(action)="data">
                <b-btn @click="removeFromQueue(data.item.id)"
                       variant="danger"
                       size="sm"
                       :disabled="data.item.scheduled_notification.status !== 'waiting'">
                  <i class="mdi mdi-eye"></i>
                  {{ $t('pages.queue.remove') }}
                </b-btn>
              </template>

              <template v-slot:cell(queued_time)="data">
                {{ data.item.scheduled_notification.send_at | date('YYYY-MM-DD / h:mm') }}
              </template>

            </b-table>
            <div class="row">
              <div class="col-sm">
                <Pagination :meta="queue.meta"></Pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import queryBuilder from "../../../mixins/queryBuilder";
import QueueService from "../../../Services/Api/QueueService";
import PerPageSelector from "../../../components/PerPageSelector";
import Swal from "sweetalert2";

export default {
  name: "Queue",
  mixins: [queryBuilder],
  components: {
    PerPageSelector
  },
  page() {
    return {
      title: this.$t('pages.queue.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  data() {
    return {
      fields: [
        {key: 'campaign', sortable: false, label: this.$t('pages.queue.fields.campaign')},
        {key: 'order_id', sortable: false, label: this.$t('pages.queue.fields.order_id')},
        {key: 'feedback_status', sortable: false, label: this.$t('pages.queue.fields.status')},
        {key: 'queued_time', sortable: false, label: this.$t('pages.queue.fields.time')},
        {key: 'action', sortable: false, label: this.$t('pages.queue.fields.action')},
      ],
      feedbackStatus: {
        waiting: {
          text: this.$t('pages.queue.feedback_status.waiting'),
          variant: 'info'
        },
        cancelled: {
          text: this.$t('pages.queue.feedback_status.cancelled'),
          variant: 'danger'
        },
        sent: {
          text: this.$t('pages.queue.feedback_status.sent'),
          variant: 'success'
        }
      },
      queue: [],
      items: [
        {
          text: this.$t('pages.queue.items.first'),
          href: "/campaigns",
        },
        {
          text: this.$t('pages.queue.items.second'),
          active: true,
        },
      ],
      title: this.$t('pages.queue.title'),
    }
  },
  methods: {
    async getQueue(params = this.query) {
      this.query = {...this.query, ...params}
      const query = this.buildQuery()
      const {data: queue} = await QueueService.all({query})
      this.queue = queue
      return queue.data
    },
    async removeFromQueue(queueId) {
      Swal.fire({
        title: this.$t('pages.queue.delete_title'),
        icon: "error",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#34c38f",
        confirmButtonText: this.$t('pages.queue.delete_confirm')
      }).then(result => {
        if (result.value) {
          QueueService.destroy({id: queueId}).then(() => {
            this.$refs.queueTable.refresh()
          })
        }
      });

    }
  }
}
</script>

<style scoped>

</style>